<template>
  <v-app>
    <v-content>
      <div class="portlet-hankeikkuna-government-timeline">
        <ConfigurationView v-if="showConfigurationView" :configurationData="configurationData" :jsonApi="jsonApi"/>
        <PortletView v-else :configurationData="configurationData" :jsonApi="jsonApi" :image-path="imagePath"/>
      </div>
    </v-content>
  </v-app>
</template>

<script>

import ConfigurationView from "./components/ConfigurationView"
import PortletView from './components/PortletView'

export default {
  name: 'App',
  components: {
      ConfigurationView,
      PortletView
  },
  props: {
    locale: String,
    configuration: String,
    configurationJson: String,
    jsonApi: String,
    imagePath: String
  },

  data() {
    return {
      configurationData: null,
    }
  },

  computed: {
    showConfigurationView() {
      return this.configuration === 'true'
    }
  },

  methods: {
    getCurrentLocale() {
      if (this.locale) {
        return this.locale;
      } else {
        return 'fi';
      }
    },
    getDefaultConfiguration() {
      return {
        hallitusUuid: null,
        rakenneElementtiUuid: null
      }

      // QA data
      // return {
      //   hallitusUuid: "468be5f6-0e77-4ad8-afc9-98e3d89a2dc7",
      //   rakenneElementtiUuid: "118856cc-1424-420c-a4ed-8653f636d05d"
      // }

      // return {
      //   hallitusUuid: "84d87f99-e0b7-4f87-88d0-1f26dd1f44d8",
      //   rakenneElementtiUuid: "6ab8e105-0bab-44b6-abc1-0733da0cbaa7"
      // }
    }
  },

  beforeMount() {
      this.$translate.setLang(this.getCurrentLocale());
      this.configurationData = this.configurationJson ? JSON.parse(this.configurationJson) : this.getDefaultConfiguration();
  },

};
</script>

<style lang="scss">

  .app_container {
    #app.v-application {
      background: white;
      font-family: myriad-pro, sans-serif;

      .v-application--wrap {
        min-height: auto !important;
      }
    }
  }

  // Breakpoints are taken from liferay to override Vuetify breakpoints
  @media (min-width: 767.9px) {
    .container {
      max-width: 767.99px;
    }
  }

  @media (min-width: 768px) {
    .container {
      max-width: 768px;
    }
  }

  @media (min-width: 1024px) {
    .container {
      max-width: 970px;
    }
  }

  .aui .portlet-hankeikkuna-government-timeline, .portlet-hankeikkuna-government-timeline {
    margin: 0 0 30px 0;
    font-size: 14px;
    
    .container {
      padding: 0;
      width: 100%;
    }
  }

  .aui {
    .v-application--wrap {
      min-height: auto;
    }
  }
</style>